import { CompletionChart } from "./components/CompletionChart";
import { MetricsOverview } from "./components/MetricsOverview";
import { ViewersChart } from "./components/ViewersChart";

export const AnalyticsTab = () => (
  <div className="mx-auto w-full p-6 md:w-5/6">
    <MetricsOverview />
    <ViewersChart />
    <CompletionChart />
  </div>
);
